import styled from 'styled-components';

export default styled.h1`
  font-size: 2rem;
  line-height: 3rem;
  margin-bottom: 1.5rem;
`;
